module.exports = __webpack_public_path__ + "media/images/xpass/landing_page/walk-to-win-f2fa1e1825430d1785d1a82de4d4fb4c.png";